<template>
  <div>
    <Editor
      :poster-state="posterState"
      :sound-data="soundData"
      :is-loading="isLoading"
      @audioAvailable="onAudioAvailable"
    />
    <span style="display:none;" id="alignmentNotifier">landscape</span>
  </div>
</template>

<script>
import Editor from './components/Editor'
import { initialSoundData } from './data/soundData'
import * as posterProvider from './provider/posterProvider'

export default {
  name: 'App',
  components: {
    Editor,
  },
  async mounted() {
    const state = await posterProvider.init(this)

    this.posterState = state.posterState
    this.soundData = state.soundData
    this.isLoading = false
  },
  data() {
    return {
      posterState: {},
      soundData: {},
      isLoading: true,
    }
  },
  methods: {
    onAudioAvailable(data) {
      this.soundData = data.soundData
      this.soundData.fourier = initialSoundData.fourier
      this.posterState.heading = ''
    },
  },
}
</script>

<style>
@import './assets/styles/input.css';
@import './assets/styles/general.css';
@import './assets/styles/poster.css';
@import './assets/styles/menu.css';
</style>
